import { IDecayFactor } from '@models/decay/decay-factors';
import { ICalibration } from '@models/calibrations/calibration';
import { ICalibrationChangelog } from '@models/calibrations/calibration-changelog';
import { IDecayEstimate } from '@models/decay/decay-estimate';
import { CalibrationStatus } from '@models/record-status';

export interface IDecayCalibration extends ICalibration {
  DecayCalibrationId: number;
  ProductId: number;
  StartDate: string;
  ExcludeAcquisitionIds: number[];
  DateTimeCreated: string;
  UserIdCreated: number;
  DateTimeModified: string;
  UserIdModified: number;
  FormId: string;
  RecordStatus: CalibrationStatus;
  LastObservationDate?: Date;
  DecayEstimateSetting?: IDecayEstimate[];
  ChangeLogs?: ICalibrationChangelog<IDecayCalibration>[];
  Expanded?: boolean;
  Comment?: string;
  DecayCalibrationType: number;
  DecayFactors?: IDecayFactor[];
  ImpliedCurtailment?: number;
}

export interface IDecayCalibrationSaveRequestDTO extends IDecayCalibration {
  Comment: string;
  DecayEstimateSetting?: IDecayEstimate[];
}

export const emptyDecayCalibration: IDecayCalibration = {
  DecayCalibrationId: -1,
  ProductId: null,
  Comment: null,
  StartDate: null,
  ExcludeAcquisitionIds: [],
  DecayEstimateSetting: [],
  DateTimeCreated: null,
  DateTimeModified: null,
  UserIdCreated: -1,
  UserIdModified: null,
  FormId: 'New Decay Calibration',
  RecordStatus: CalibrationStatus.Active,
  DecayCalibrationType: -1
};

export enum DECAY_TOASTS {
  // Actions
  SaveSuccess,
  SaveAndApproveSuccess,
  ProposedSuccess,
  ApprovedSuccess,
  RejectedSuccess,

  // Errors
  SaveError,
  SaveAndApproveError,
  ProposedError,
  ApprovedError,
  RejectedError
}

export enum FORM_IDs {
  Save = 'Propose Form',
  SaveAndApprove = 'Save-Approve Form',
  Approve = 'Approval Form',
  Reject = 'Rejection Form'
}
